import Link from 'next/link';
import React from 'react';
import clsx from 'clsx';
import { ChevronRight } from 'react-feather';
import { useRouter } from 'next/router';
import analytics from 'app/utils/analytics';

interface BreadcrumbsProps {
  items: { title: string; href: string }[];
  variant?: 'primary' | 'inverted';
}

const Breadcrumbs = ({ items, variant = 'primary' }: BreadcrumbsProps) => {
  const router = useRouter();

  let activeTextClassname = '';
  let inactiveTextClassname = '';
  let separatorClassname = '';

  if (variant === 'primary') {
    activeTextClassname = 'text-neutral-700';
    inactiveTextClassname = 'text-blue-500';
    separatorClassname = 'text-neutral-700';
  } else if (variant === 'inverted') {
    activeTextClassname = 'text-white';
    inactiveTextClassname = 'text-white';
    separatorClassname = 'min-w-4 text-white';
  }

  return (
    <nav>
      <ol className="flex items-center gap-2">
        {items.map((item, index) => {
          const isActive = item.href === router.asPath;
          const isLoneItem = items.length === 1;
          const isLastIndex = index === items.length - 1;
          return (
            <>
              {/* eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions */}
              <li
                onClick={() => {
                  analytics.trackClickProductBreadcrumb({
                    title: item.title,
                  });
                }}
                key={item.title}
              >
                {isActive ? (
                  <p className={clsx('text-sm truncate', activeTextClassname)}>
                    {item.title}
                  </p>
                ) : (
                  <p
                    className={clsx(
                      'text-sm cursor-pointer truncate',
                      inactiveTextClassname,
                    )}
                  >
                    <Link href={item.href}>{item.title}</Link>
                  </p>
                )}
              </li>
              {!isLastIndex && !isLoneItem && (
                <ChevronRight
                  className={clsx(['min-w-[16px]', separatorClassname])}
                  size={16}
                />
              )}
            </>
          );
        })}
      </ol>
    </nav>
  );
};

export default Breadcrumbs;
